module.exports = __webpack_public_path__ + "static/media/add_circle.b4409b8a.svg";